import { reducer as userConfigurationReducer } from '@noths/polaris-client-user-configuration';
import { reducer as favouritesReducer } from '@noths/polaris-client-user-favourites';
import { combineReducers } from '@reduxjs/toolkit';
import { routerReducer } from 'connected-next-router';

import { reducer as filterReducer } from 'src/components/organisms/Filter';
import { reducer as filterMenuReducer } from 'src/components/organisms/FilterMenu';
import { reducer as accessibilityReducer } from './accessibility';
import { reducer as navigationReducer } from './navigation';
import { reducer as productReducer } from './products';
import { reducer as richRelevanceReducer } from './richRelevance';
import { reducer as visibilityTrackingReducer } from './visibilityTracking';

export const combinedReducer = combineReducers({
  accessibility: accessibilityReducer,
  filter: filterReducer,
  filterMenu: filterMenuReducer,
  navigation: navigationReducer,
  products: productReducer,
  router: routerReducer,
  userConfiguration: userConfigurationReducer,
  favourites: favouritesReducer,
  richRelevance: richRelevanceReducer,
  visibilityTracking: visibilityTrackingReducer,
});

export type ReduxApplicationState = ReturnType<typeof combinedReducer>;
